document.addEventListener("DOMContentLoaded", () => {
  const continueShippingElement = document.getElementById("cart-added-dialog");

  const cartAddedDialog = basicLightbox.create(
    `${continueShippingElement.innerHTML}`,
    {
      className: "continue-shipping-dialog",
      onClose: () => {
        const body = document?.body;
        if (body) body.style.overflow = "auto";

        window.scrollTo(0, 0);
      },
      closable: false,
      onShow: () => {
        const body = document?.body;
        window.scrollBy(0, 10);
        if (body) body.style.overflow = "hidden";
        if (reloadCartNumber) reloadCartNumber();
      },
    }
  );

  function handleModalCartAdded({ detail }) {
    const { items } = detail;
    const mainItem = items ? items[0] : null;
    if (mainItem) {
      cartAddedDialog.show();
      const _wrapper = document.querySelector(
        ".continue-shipping-dialog .basicLightbox__placeholder"
      );
      const mainPreviewImage = _wrapper.querySelector(".js-product-image");
      const mainProductTitle = _wrapper.querySelector(".js-product-title");
      const mainVariantWrapper = _wrapper.querySelector(".js-product-variants");
      const mainQuantityWrapper = _wrapper.querySelector(
        ".js-product-quantity"
      );

      const closeBtn = _wrapper.querySelector(
        "#close-continue-shipping-dialog"
      );
      closeBtn.addEventListener("click", () => {
        cartAddedDialog.close();
      });

      const cancelBtn = _wrapper.querySelector(".js-btn-continue");
      cancelBtn.addEventListener("click", () => {
        cartAddedDialog.close();
      });

      const gotoCartBtn = _wrapper.querySelector(".js-btn-cart");
      gotoCartBtn.addEventListener("click", () => {
        window.location.href = window?.Shopify?.routes?.cart_url || "/cart";
      });

      mainVariantWrapper.innerHTML = "";
      mainQuantityWrapper.innerHTML = "";
      const mainProductPrice = _wrapper.querySelector(".js-product-price");
      mainPreviewImage.src = mainItem?.image;

      if (window?.BuildYou?.publicPreviewUrl) {
        mainPreviewImage.src = window?.BuildYou?.publicPreviewUrl;
      }

      if (window?.engraver?.canvas) {
        mainPreviewImage.src = window?.engraver?.canvas.toDataURL({
          format: "jpeg",
          quality: 0.7,
        });
      }

      if (window?.buildyouCanvas) {
        mainPreviewImage.src = window?.buildyouCanvas.toDataURL({
          format: "png",
          quality: 0.7,
        });
      }
      mainProductTitle.innerText = mainItem.product_title;
      const currencySymbol = mainProductPrice?.dataset?.currencySymbol;
      const priceElement = document.querySelector(
        "h2.product-price:not(.wp-hidden) .wp-text-secondary"
      );
      if (priceElement) {
        mainProductPrice.innerText = priceElement.innerText;
      } else {
        mainProductPrice.innerText = `${currencySymbol ? currencySymbol : "$"}${
          mainItem.presentment_price
        } ${window?.Shopify?.currency?.active || ""}`;
      }
      const quantityWrapper = document.createElement("p");
      const quantityValue = document.createElement("span");
      quantityWrapper.className =
        "md:wp-text-base wp-text-[#9f9f9f] wp-test-[14px]";
      quantityValue.className =
        "wp-leading-6 wp-font-normal wp-text-black wp-text-[14px] md:wp-text-base";

      quantityWrapper.innerText = `Quantity: `;
      quantityValue.innerText = mainItem.quantity;
      quantityWrapper.appendChild(quantityValue);
      mainQuantityWrapper.appendChild(quantityWrapper);
      for (const option of mainItem.options_with_values) {
        const optionWrapper = document.createElement("p");
        const optionValue = document.createElement("span");
        optionWrapper.className =
          "md:wp-text-base wp-text-[#9f9f9f] wp-test-[14px]";
        optionValue.className =
          "wp-leading-6 wp-font-normal wp-text-black wp-text-[14px] md:wp-text-base";
        optionWrapper.innerText = `${option.name}: `;
        optionValue.innerText = option.value.split("|")[0];
        optionWrapper.appendChild(optionValue);
        mainVariantWrapper.appendChild(optionWrapper);
      }
      const extraWrapper = _wrapper.querySelector(".js-extra-wrapper");
      const extraList = _wrapper.querySelector(".js-extra-list");
      if (extraList) {
        extraList.innerHTML = "";
      }
      if (items.length > 1) {
        extraWrapper.classList.remove("wp-hidden");
        for (let index = 1; index < items.length; index++) {
          const element = items[index];
          if (extraList) {
            const extraItem = document.createElement("li");
            const elQuantity = document.createElement("b");
            elQuantity.innerText = `• ${mainItem.quantity}x `;

            const elTitle = document.createTextNode(element.title);

            extraItem.appendChild(elQuantity);
            extraItem.appendChild(elTitle);

            extraList.append(extraItem);
          }
        }
      } else {
        extraWrapper.classList.add("wp-hidden");
      }
    }
  }

  window.addEventListener("eb-add-to-cart-success", handleModalCartAdded);
  window.addEventListener("by:addToCartSuccess", handleModalCartAdded);
  window.addEventListener("cart:added", handleModalCartAdded);
});
